import React from 'react';
import { BrandType } from '@/utils/common.types';

interface Props {
  brand: BrandType;
}

const BrandLogo = ({ brand }: Props) => {
  return (
    <div>
      <img
        src={brand?.logo?.svg?.url}
        alt={`${brand?.brandName} logo`}
        content={brand?.logo?.svg?.contentType}
        className="sm-max-h-[80px] sm-max-w-[40%] max-h-[100px] max-w-[45%]"
      />
    </div>
  );
};

export default BrandLogo;
